import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

/**
 * Calculates the age in years based on the provided date of birth (DOB).
 *
 * @param {string} dob - The date of birth as a string. Supported formats: "DD/MM/YYYY", "YYYY-MM-DD", "MM/DD/YYYY".
 * @returns {number} The calculated age in years. Returns 0 if the input is invalid or DOB is not provided.
 *
 * @example
 * getAgeFromDOB("01/01/2000"); // returns the age based on the current date
 */
export const getAgeFromDOB = (dob) => {
  if (!dob) return 0;

  const parsed = dayjs(dob, ["DD/MM/YYYY", "YYYY-MM-DD", "MM/DD/YYYY"], true);
  if (!parsed.isValid()) return 0;

  const today = dayjs();
  let age = today.year() - parsed.year();

  if (
    today.month() < parsed.month() ||
    (today.month() === parsed.month() && today.date() < parsed.date())
  ) {
    age--; // birthday hasn't occurred yet this year
  }

  return age;
};
